import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  byCategory: {},
  isLoading: false,
  error: null,
};

const toByCategory = (list) => {
  const map = {};
  (list || []).forEach((f) => {
    map[f.category] = f.values || [];
  });
  return map;
};

export const getFilters = createAsyncThunk(
  "filters/getFilters",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/filters", {
        headers: { "Content-Type": "application/json" },
      });
      return response.data?.filters || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addFilterValue = createAsyncThunk(
  "filters/addFilterValue",
  async ({ category, value }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/filters/value",
        { category, value },
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const renameFilterValue = createAsyncThunk(
  "filters/renameFilterValue",
  async ({ category, oldValue, newValue }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/api/filters/value",
        { category, oldValue, newValue },
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const removeFilterValue = createAsyncThunk(
  "filters/removeFilterValue",
  async ({ category, value }, { rejectWithValue }) => {
    try {
      const response = await axios.delete("/api/filters/value", {
        headers: { "Content-Type": "application/json" },
        data: { category, value },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const applyCategoryUpdate = (state, action) => {
  state.isLoading = false;
  const { category, values } = action.payload || {};
  if (!category) return;
  state.byCategory[category] = values || [];
  const existing = state.list.find((f) => f.category === category);
  if (existing) {
    existing.values = values || [];
  } else {
    state.list.push({ category, values: values || [] });
  }
};

export default createSlice({
  name: "filters",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFilters.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFilters.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload || [];
        state.byCategory = toByCategory(action.payload);
      })
      .addCase(getFilters.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(addFilterValue.fulfilled, applyCategoryUpdate)
      .addCase(renameFilterValue.fulfilled, applyCategoryUpdate)
      .addCase(removeFilterValue.fulfilled, applyCategoryUpdate);
  },
}).reducer;
